import { ABP, findRoute, getRoutePath, RoutesService, TreeNode } from '@abp/ng.core';
import { Component, EventEmitter, Injector, Input, OnInit, Output, TrackByFunction } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, take } from 'rxjs/operators'; 
import { LayoutService } from '../../services/layout.service';
import {HedouRoute, RoutesService as HedouRoutesService } from '@hedou/abp.metronic-ui';

@Component({
	selector: 'hedou-routes',
	templateUrl: './routes.component.html',
	styleUrls: ['./routes.component.less']
})
export class RoutesComponent implements OnInit {

	@Output() clickedToLink = new EventEmitter<MouseEvent>();

	@Input() isMenuPlacementTop: boolean;

	@Input() smallScreen: boolean;

	readonly expandedRoutes = new Set<string>();

	readonly initialLevel = 1;

	trackByFn: TrackByFunction<TreeNode<ABP.Route>> = (_, item) => item.name;
	trackGroupByFn: TrackByFunction<HedouRoute.Route> = (_, item) => item.name;

	filterOp = map((routes: TreeNode<ABP.Route>[]) => routes);

	get routeGroups$() {
		return this.hedouRoutesService.visible$;
	}

	get routes$() {
		return this.routes.visible$.pipe(this.filterOp);
	}

	ulCSSClasses: string;

	constructor(
		private router: Router,
		public readonly routes: RoutesService,
		private hedouRoutesService: HedouRoutesService,
		public readonly injector: Injector,
		private layout: LayoutService
	) {

		// this.routes.tree$.subscribe(console.log)
		hedouRoutesService.visible$.subscribe(g => {
			console.log('我是分组')
			console.log(g);
		});
	}

	isDropdown(node: TreeNode<ABP.Route>) {
		return !node?.isLeaf || this.routes.hasChildren(node.name);
	}

	ngOnInit() {
		this.ulCSSClasses = this.layout.getProp('aside_menu_nav');


	}

	onNavigate({ parentName }: ABP.Route, level: number) {


	}


}
